export type ResponseBody<T> = {
  status: string;
  code: string;
  data: T;
  success?: boolean;
};

export type ErrorResponseBody = {
  status: string;
  code: string;
  message: string;
  data?: unknown;
  /** The real numeric HTTP status (e.g. 400, 500), attached by BaseApi separately from
   *  `status`/`code`, which are string enum names and business error codes, not HTTP numbers. */
  httpStatus?: number;
};

export function isErrorType(data: unknown): data is ErrorResponseBody {
  return Boolean(
    data &&
      typeof data === 'object' &&
      (data as Record<string, string>).message &&
      (data as Record<string, string>).code
  );
}

export async function unwrapPromiseError<T>(error: unknown): Promise<T | null> {
  if (error instanceof Promise) {
    return (await error) as T;
  }

  if (typeof error === 'object' && error !== null) {
    return error as T;
  }

  return null;
}
